import * as React from "react";
const SvgNotValid = props => <svg xmlns="http://www.w3.org/2000/svg" width={18} height={16} viewBox="0 0 18 16" {...props}><circle cx={8.86} cy={8} r={8} /><path d="m5.8 4.98 6.07 6.08m0-6.12L5.8 11.02" /></svg>;
export default SvgNotValid;